module.exports = __webpack_public_path__ + "img/icon_music.826c968.png";


//////////////////
// WEBPACK FOOTER
// ./components/Icon/images/icon_music.png
// module id = oQL6
// module chunks = 9